import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from '@app/shared';
import {StockReportComponent} from '@app/modules/report/stock-report/stock-report.component';
import {VatReportComponent} from '@app/modules/report/vat-report/vat-report.component';
import {PurchaseReportComponent} from '@app/modules/report/purchase-report/purchase-report.component';
import {SaleReportComponent} from '@app/modules/report/sale-report/sale-report.component';
import {CostSheetComponent} from '@app/modules/report/cost-sheet/cost-sheet.component';
import {PurchaseVatReportComponent} from '@app/modules/report/purchase-vat-report/purchase-vat-report.component';
import {SalesVatReportComponent} from '@app/modules/report/sales-vat-report/sales-vat-report.component';
import {AgentReportComponent} from '@app/modules/report/agent-report/agent-report.component';
import {StockValueReportComponent} from '@app/modules/report/stock-value-report/stock-value-report.component';
import {WarehouseStockLogComponent} from '@app/modules/report/warehouse-stock-log/warehouse-stock-log.component';
import {TaxReportComponent} from '@app/modules/report/tax-report/tax-report.component';
import {HsnReportComponent} from '@app/modules/report/hsn-report/hsn-report.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'stock-report',
        loadComponent: () => StockReportComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/stock-report'}
      },
      {
        path: 'vat-report',
        loadComponent: () => VatReportComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/vat-report'}
      },
      {
        path: 'hsn-report',
        loadComponent: () => HsnReportComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/hsn-report'}
      },
      {
        path: 'tax-report',
        loadComponent: () => TaxReportComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/tax-report'}
      },
      {
        path: 'purchase-report',
        loadComponent: () => PurchaseReportComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/purchase-report'}
      },
      {
        path: 'sale-report',
        loadComponent: () => SaleReportComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/sale-report'}
      },
      {
        path: 'sales-vat-report',
        loadComponent: () => SalesVatReportComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/sales-vat-report'}
      },
      {
        path: 'cost-sheet',
        loadComponent: () => CostSheetComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/cost-sheet'}
      },
      {
        path: 'purchase-vat-report',
        loadComponent: () => PurchaseVatReportComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/purchase-vat-report'}
      },
      {
        path: 'agent-report',
        loadComponent: () => AgentReportComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/agent-report'}
      },
      {
        path: 'stock-value-report',
        loadComponent: () => StockValueReportComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/stock-value-report'}
      },
      {
        path: 'warehouse-stock-log',
        loadComponent: () => WarehouseStockLogComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/warehouse-stock-log'}
      },
      {
        path: 'warehouse-stock-log/:itemid',
        loadComponent: () => WarehouseStockLogComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/warehouse-stock-log'}
      },
    ],
    runGuardsAndResolvers: 'always',
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportRoutingModule {
}
